import React, { useEffect, useState } from "react";
import "./Home.css";
import Product from "./Product";
import { firestoreDB } from "../config/firebase";

function Home() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    firestoreDB
      .collection("products")
      .onSnapshot((doc) =>
        setProducts(doc.docs.map((product) => product.data()))
      );
  }, []);

  return (
    <div className="home">
      <div className="home__container">
        <img
          className="home__image"
          src="https://m.media-amazon.com/images/I/71qid7QFWJL._SX3000_.jpg"
          alt=""
        />

        <div className="home__row">
          {products.map((prod) => (
            <div className="row__child">
              <Product
                id={prod.id}
                key={prod.id}
                title={prod.title}
                price={prod.price}
                image={prod.image}
                rating={prod.rating}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Home;
